import React from "react";
import TitlePage from "../../../app/Title/TitlePage/TitlePageView";
import Grid from "@material-ui/core/Grid";
import {Button} from "primereact/button";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import LoanData from "../../../components/loanData";
import GuaranteeForChange from "../../../components/guaranteeForChange";
import GuaranteeInAccount from "../../../components/guaranteeInAccount";
import NumberFormat from "react-number-format";
import {InputText} from "primereact/inputtext";
import SubtitleLabel from "../../../app/Title/SubtitleLabel/SubtitleLabelView";
import LoadingOverlay from 'react-loading-overlay';

const ExtensionLoan = ({...props}) => {
    return (
        <React.Fragment>
            <LoadingOverlay
                active={props.isLoading}
                spinner
                text='Loading...'>
                <Paper elevation={5}
                       style={{paddingTop: '1%', paddingBottom: '2%', paddingLeft: '2%', paddingRight: '2%'}}>
                    {props.messagesGrowl}
                    {props.extensionConfMsg}
                    {props.guaranteeConfMsg}
                    <Grid container spacing={1}>
                        <Grid item xs={6}>
                            <TitlePage title="Tablero de Control \ Prórroga"/>
                        </Grid>
                        <Grid item xs={6}>
                            <Grid container spacing={2} justify="flex-end">
                                <Grid item>
                                    <Button
                                        label="Regresar"
                                        style={{'float': 'right'}}
                                        className="p-button-secondary"
                                        onClick={props.handleReturnButton}/>
                                </Grid>
                                {props.extensionType === 'N' &&
                                <Grid item>
                                    <Button
                                        label="Sustitución"
                                        style={{'float': 'right'}}
                                        className="p-button-secondary"
                                        onClick={props.changeGuaranteeScreen}/>
                                </Grid>
                                }
                                {props.extensionType !== 'N' &&
                                <Grid item>
                                    <Button label="Agregar Garantía" className="p-button-secondary"
                                            onClick={props.redirectAddInstrument}
                                    /> &nbsp;
                                </Grid>
                                }
                                <Grid item>
                                    <Button
                                        label="Validar Solicitud"
                                        style={{'float': 'right'}}
                                        onClick={props.validateExtensionPr}/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <LoanData
                            loanId={props.loanId}
                            selectedLoan={props.selectedLoan}
                            loading={props.loading}
                            isPrecio24Hrs={true}
                            isExtension={true}
                            ref={props.loanData}
                        />
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <Grid item xs={12}>
                            <div className="p-grid">
                                <div className="p-col-3">
                                    <SubtitleLabel header="Nuevo Plazo" isBold={true}/>
                                    <NumberFormat className={"p-inputtext p-component p-filled"}
                                                  name="plazo"
                                                  value={props.extensionData.plazo}
                                                  thousandSeparator={true}
                                                  decimalScale={0}
                                                  onChange={props.saveData}
                                                  disabled={props.disableValues}
                                                  maxLength={5}
                                                  allowNegative={false}
                                    />
                                </div>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Nueva Tasa" isBold={true}/>
                                    <NumberFormat id={8}
                                                  name="tasa"
                                                  value={props.extensionData.tasa}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  onChange={props.saveData}
                                                  disabled={props.disableValues}
                                                  allowNegative={false}
                                                  customInput={InputText}
                                    />
                                </div>
                                <div className="p-col-3">
                                    <SubtitleLabel header="Nueva Sobretasa" isBold={true}/>
                                    <NumberFormat id={8}
                                                  name="sobretasa"
                                                  value={props.extensionData.sobretasa}
                                                  thousandSeparator={true}
                                                  decimalScale={2}
                                                  onChange={props.saveData}
                                                  disabled={props.disableValues}
                                                  allowNegative={false}
                                                  customInput={InputText}
                                    />
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <GuaranteeForChange
                            ref={props.guaranteeForChange}
                            loading={props.loading}
                            loanId={props.loanId}
                            loanType={props.selectedLoan.loanType}
                            updateGuaranteeTotal={props.updateGuaranteeTotal}
                            readOnly={true}
                            isPrecio24Hrs={true}
                        />
                        <Grid item xs={12}>
                            <Divider/>
                        </Grid>
                        <GuaranteeInAccount
                            ref={props.guaranteeInAccount}
                            guaranteeAmountInLoanTotal={props.guaranteeAmount}
                            loading={props.loading}
                            loanId={props.loanId}
                            maturity={1}
                            account={props.account}
                            isHidden={true}
                            isPrecioVal={!props.extensionType === 'S'}
                        />
                    </Grid>
                </Paper>
            </LoadingOverlay>
        </React.Fragment>
    )
};

export default ExtensionLoan;